import { object } from 'yup'
import { MultiStepSchema } from 'components/Wizards/schemas/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { designProject } from 'components/Wizards/schemas/shared/designProject'
import { designTopic } from 'components/Wizards/schemas/shared/designTopic'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { language } from 'components/Wizards/schemas/shared/language'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { meta } from '../schemaCommon'

export const FlowZ2Schema = ({ generationType }: { generationType: string }) => {
  const RefineCaptionDetails = object({
    topic: designTopic
      .meta({
        label: `What is it about?`,
        generate: false,
        generationType,
      })
      .required(),
    brand_kit_id: brandKitId.optional(),
    tone: tone.optional().meta({ generationType }),
    language: language,
    filename: filename.optional(),
    project: designProject.optional(),
  }).meta({
    title: 'What do you need a script for?',
    type: generationType,
    stepId: 'RefineCaptionDetails',
  })

  return {
    meta: {
      ...meta,
    },
    steps: [RefineCaptionDetails],
  } as MultiStepSchema<ChannelType>
}
